import CityPageTemplate from "../city-template/CityPageTemplate";
import { tellurideConfig } from "./data";

export default function TelluridePage() {
  return <CityPageTemplate config={tellurideConfig} />;
}